import React from "react";
import PropTypes from "prop-types"
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import {STRIPE_PUBLIC_KEY} from "../../constants/ConfigFromBuildEnvironment";
import Time from "../../utils/Time";
import Money from "../../utils/Money";


class CheckoutView extends React.Component {

    static propTypes = {
        isSaving: PropTypes.bool.isRequired,
        isPayFailed: PropTypes.bool.isRequired,
        clientSecret: PropTypes.string.isRequired,
        reservationRequestId: PropTypes.number.isRequired,
        cardInputsValid: PropTypes.bool.isRequired,
        cardErrorMessage: PropTypes.string.isRequired,
        paymentErrorMessage: PropTypes.string.isRequired,
        advertisementId: PropTypes.number.isRequired,
        advertisementTitle: PropTypes.string.isRequired,
        spaceId: PropTypes.number.isRequired,
        spaceTitle: PropTypes.string.isRequired,
        startDate: PropTypes.string.isRequired,
        endDate: PropTypes.string.isRequired,
        pricePerDay: PropTypes.number.isRequired,
        amount: PropTypes.number.isRequired,
        taxRate: PropTypes.number.isRequired,
        taxesDue: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
    };

    constructor(props) {
        super(props);
        this.stripe = window.Stripe(STRIPE_PUBLIC_KEY);
        this.card = null;
    }

    componentDidMount() {
        if (this.card === null) {
            this.attachStripe();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.card === null) {
            this.attachStripe();
        }
    }

    componentWillUnmount() {
    }

    attachStripe() {
        const elements = this.stripe.elements();
        const stripeStyle = {
            base: {
                color: "#32325d",
                fontFamily: 'Arial, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#32325d"
                }
            },
            invalid: {
                fontFamily: 'Arial, sans-serif',
                color: "#fa755a",
                iconColor: "#fa755a"
            }
        };
        this.card = elements.create("card", { style: stripeStyle });

        const elem = document.getElementById("stripe-card-element");
        this.card.mount(elem); // Stripe injects an iframe into the DOM

        this.card.on("change", function (event) {
            // Disable the Pay button if there are no card details in the Element
            EventPublisher.publish(UIInteractionEvents.CHECKOUT_CARD_DETAILS_CHANGED, {
                validInputs: event.empty,
                cardErrorMessage: event.error ? event.error.message : ""
            });
        });

    }

    handleFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        EventPublisher.publish(
            UIInteractionEvents.CHECKOUT_PAY_CLICKED,
            {
                reservationRequestId: this.props.reservationRequestId,
                stripe: this.stripe,
                card: this.card,
                clientSecret: this.props.clientSecret,
            }
        );
    };

    handlePaymentFailureCloseClick = (event) => {
        EventPublisher.publish(UIInteractionEvents.CHECKOUT_PAYMENT_FAILURE_CLEAR_CLICKED, {});
    };

    handleCancelClicked = (event) => {
        EventPublisher.publish(UIInteractionEvents.CHECKOUT_CANCEL_CLICKED, {});
    };

    render() {

        const startDate = Time.parseDate(this.props.startDate);
        const endDate = Time.parseDate(this.props.endDate);
        const timeSpanDays = Time.calculateDifferenceInDaysBetweenInclusive(startDate, endDate);

        let cardValidationErrorAlert = null;
        if (!this.props.cardInputsValid && this.props.cardErrorMessage.length > 0) {
            cardValidationErrorAlert = (
                <div className="row justify-content-center">
                    <div className="alert alert-danger" role="alert">
                        {this.props.cardErrorMessage}
                    </div>
                </div>
            );
        }
        let paymentErrorAlert = null;
        if (this.props.isPayFailed) {
            paymentErrorAlert = (
                <div className="row justify-content-center">
                    <div className="alert alert-warning alert-dismissible fade show" role="alert">
                        <strong>Payment Error!</strong> {this.props.paymentErrorMessage}
                        <button type="button" className="close" aria-label="Close" onClick={this.handlePaymentFailureCloseClick}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                Checkout Reservation
                                <span className="ml-auto float-right">
                                    <button
                                        className="btn btn-primary"
                                        onClick={this.handleCancelClicked}
                                    >
                                        Cancel
                                    </button>
                                </span>
                            </div>
                            <div className="card-body">

                                <div className="row justify-content-center mb-3">
                                    <form className="stripe-width">
                                        <div className="form-group row mb-1">
                                            <label htmlFor="staticAdvertisement" className="col-sm-4 col-form-label font-weight-bold">Advertisement:</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control-plaintext"
                                                    id="staticAdvertisement"
                                                    value={this.props.advertisementTitle}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-1">
                                            <label htmlFor="staticSpace" className="col-sm-4 col-form-label font-weight-bold">Space:</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control-plaintext"
                                                    id="staticSpace"
                                                    value={this.props.spaceTitle}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-1">
                                            <label htmlFor="staticDates" className="col-sm-4 col-form-label font-weight-bold">Dates:</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control-plaintext"
                                                    id="staticDates"
                                                    value={startDate.toLocaleDateString() + " -> " + endDate.toLocaleDateString()}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-1">
                                            <label htmlFor="staticDayss" className="col-sm-4 col-form-label font-weight-bold"># of Days:</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control-plaintext"
                                                    id="staticDayss"
                                                    value={timeSpanDays}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-1">
                                            <label htmlFor="staticPPD" className="col-sm-4 col-form-label font-weight-bold">Price Per Day:</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control-plaintext"
                                                    id="staticPPD"
                                                    value={Money.formatMoney(this.props.pricePerDay)}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-1">
                                            <label htmlFor="staticAmount" className="col-sm-4 col-form-label font-weight-bold">Amount:</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control-plaintext"
                                                    id="staticAmount"
                                                    value={Money.formatMoney(this.props.amount)}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-1">
                                            <label htmlFor="staticTaxes" className="col-sm-4 col-form-label font-weight-bold">Taxes:</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control-plaintext"
                                                    id="staticTaxes"
                                                    value={Money.formatMoney(this.props.taxesDue)}
                                                />
                                                <small id="taxesDueHelpBlock" className="form-text text-muted float-right">
                                                    Applicable Tax Rate: {this.props.taxRate}
                                                </small>
                                            </div>
                                        </div>
                                        <div className="form-group row mb-1">
                                            <label htmlFor="staticTotal" className="col-sm-4 col-form-label font-weight-bold">Total Cost:</label>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    readOnly
                                                    className="form-control-plaintext"
                                                    id="staticTotal"
                                                    value={Money.formatMoney(this.props.total)}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <form>
                                    <div className="row justify-content-center">
                                        <div className="stripe-form">
                                            <div id="stripe-card-element" className="stripe-input"/>
                                            <button
                                                type="submit"
                                                className="stripe-button"
                                                onClick={this.handleFormSubmit}
                                                disabled={this.props.isSaving || this.props.isPayFailed}
                                            >
                                                {
                                                    this.props.isSaving ?
                                                        (
                                                            <span>
                                                    <span className="spinner-border spinner-border-sm mr-1"/>
                                                    Attempting Payment...
                                                </span>
                                                        ) :
                                                        "Pay"
                                                }
                                            </button>
                                            {cardValidationErrorAlert}
                                            {paymentErrorAlert}
                                            <small id="displayNameHelpBlock" className="form-text text-muted float-right">
                                                Powered By <i className="fab fa-cc-stripe fa-lg ml-1 text-stripe bg-light"/>
                                            </small>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default CheckoutView;